module.exports = __webpack_public_path__ + "img/tema-3-1.d914516b.svg";